import { FavouriteTransaction } from '../../entities/FavouriteTransaction';
import { EditFavouriteTransactionRequestDTO } from '../../entities/FavouriteTransaction/EditFavouriteTransactionRequestDTO';

const favouriteTransactionToEditFavouriteTransactionRequestDTOAdapter = (
  data: FavouriteTransaction,
): EditFavouriteTransactionRequestDTO =>
  new EditFavouriteTransactionRequestDTO(
    data.appTransactionId,
    JSON.stringify({
      AppTransactionId: data.appTransactionUniqueId,
      Description: data.alias,
      FromAccount: data.fromAccount,
      ToMyAccount: data.toAccount,
      Amount: data.amount,
    }),
    data.description,
    parseInt(data.status),
    data.enabled,
  );

export { favouriteTransactionToEditFavouriteTransactionRequestDTOAdapter };
